/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterUSmall = createReactComponent("outline", "letter-u-small", "IconLetterUSmall", [["path", { "d": "M10 8v6a2 2 0 1 0 4 0v-6", "key": "svg-0" }]]);

export { IconLetterUSmall as default };
//# sourceMappingURL=IconLetterUSmall.mjs.map
